import { Modal } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { TimeOutWrap } from './style';
import { logout } from 'redux/slices/authSlice';
import { resetDomainState } from 'redux/slices/selectedNodeSlice';
import { ReactComponent as Timeout } from 'assets/images/SVG/icons/timeout-icon.svg';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { resetTreeState } from 'redux/slices/treedata';
import { resetOuTreeState } from 'redux/slices/ouAdminTree';
import { setSelectedItems } from 'redux/slices/userSlice';
import { setGroupSelectedItems } from 'redux/slices/getOuGroups';

const InterfaceModal = ({ modalopen, setModalOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleTokenExpiration = async () => {
    localStorage.setItem('previousPath', location.pathname);
    localStorage.setItem('previousAccount', localStorage.getItem('userName'));
    await dispatch(logout());
    dispatch(setSelectedItems([]));
    dispatch(setGroupSelectedItems([]));
    dispatch(resetDomainState());
    dispatch(resetTreeState());
    dispatch(resetOuTreeState());
    setModalOpen(false);
    navigate('/login');
  };
  return (
    <Modal
      className='logoutmodal af-interface-session-modal'
      style={{ top: 20 }}
      open={modalopen}
      footer={null}
      closable={false}
      mask={true}
      width={400}
    >
      <TimeOutWrap className='af-interface-session-timeout-wrap'>
        <Timeout className='af-interface-session-timeout' style={{ alignContent: 'center', marginRight: '8px' }} />
        <p className='af-interface-session-content' style={{ color: '#ff6666', fontSize: '20px', margin: '0px' }}>
          Your session has been timed out.
        </p>
        <StyledButton className='af-interface-session-button' type='primary' onClick={handleTokenExpiration}>
          Login
        </StyledButton>
      </TimeOutWrap>
    </Modal>
  );
};

export default InterfaceModal;
